<script setup lang="ts">
import { ProductSize } from '~/lib/services/store/catalog/catalog.dtos'
import { ProductSizeType } from '~/lib/services/store/common.dto'
const props = defineProps<{
  size: ProductSize
  productId: string
  upsellingPrice: string
}>()

const emit = defineEmits(['change-size'])

const { t } = useLocale()
const { trackSelectSize } = useGTM()

const isSizeSelected = computed(() => props.size.code === props.productId)
const isSizeLargeAndNotSelected = computed(
  () => props.size.id === ProductSizeType.LARGE && !isSizeSelected.value
)

const changeSize = () => {
  if (isSizeSelected.value) return
  trackSelectSize(props.size.id)
  emit('change-size', props.size.code)
}
</script>

<template>
  <div
    data-test="product-size"
    class="mx-2 flex max-w-16 cursor-pointer flex-col items-center gap-3"
    @click="changeSize"
  >
    <div
      :class="{ 'product-size--selected': isSizeSelected }"
      class="relative h-16 w-16 rounded-[50%] border border-mcd-secondaryGrey"
    >
      <span
        class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-lg"
        :class="{ 'font-bold': isSizeSelected }"
      >
        {{ t(`productDetail.sizes.types.${size.id}.letter`) }}
      </span>

      <img
        v-if="isSizeSelected"
        class="absolute right-0 top-0 h-fit w-4"
        src="/images/icons/store-check.svg"
        alt="selected"
      />
    </div>
    <p class="text-center text-sm" :class="{ 'font-bold': isSizeSelected }">
      {{ t(`productDetail.sizes.types.${size.id}.title`) }}
    </p>
    <UpsellingBubble
      v-if="isSizeLargeAndNotSelected && upsellingPrice"
      :upselling-price="upsellingPrice"
    />
  </div>
</template>

<style scoped>
.product-size--selected {
  @apply border-2 border-mcd-main;
}
</style>
